// extracted by mini-css-extract-plugin
module.exports = {"container":"GlobalDesktopHeaderNavigation_container__3058d","sending":"GlobalDesktopHeaderNavigation_sending__ESvcY"};